import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { FinanceThresholdService } from '../../services/finance-threshold.service';
import * as FinanceThresholdActions from './finance-thresholds.actions';

@Injectable()
export class FinanceThresholdEffects {
  private actions$ = inject(Actions);
  private financeThresholdService = inject(FinanceThresholdService);

  loadFinanceThresholds$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FinanceThresholdActions.loadFinanceThresholds),
      switchMap(() =>
        this.financeThresholdService.getFinanceThresholds().pipe(
          map((thresholds) => FinanceThresholdActions.loadFinanceThresholdsSuccess({ thresholds })),
          catchError((error) => of(FinanceThresholdActions.loadFinanceThresholdsFailure({ error })))
        )
      )
    );
  });

  addFinanceThreshold$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FinanceThresholdActions.addFinanceThreshold),
      concatMap((action) =>
        this.financeThresholdService.createFinanceThreshold(action.threshold).pipe(
          map((threshold) => FinanceThresholdActions.addFinanceThresholdSuccess({ threshold })),
          catchError((error) => of(FinanceThresholdActions.addFinanceThresholdFailure({ error })))
        )
      )
    );
  });

  updateFinanceThreshold$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FinanceThresholdActions.updateFinanceThreshold),
      concatMap((action) =>
        this.financeThresholdService.updateFinanceThreshold(action.id, action.changes).pipe(
          map((threshold) => FinanceThresholdActions.updateFinanceThresholdSuccess({ threshold })),
          catchError((error) => of(FinanceThresholdActions.updateFinanceThresholdFailure({ error })))
        )
      )
    );
  });

  deleteFinanceThreshold$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FinanceThresholdActions.deleteFinanceThreshold),
      concatMap((action) =>
        this.financeThresholdService.deleteFinanceThreshold(action.id).pipe(
          map(() => FinanceThresholdActions.deleteFinanceThresholdSuccess({ id: action.id })),
          catchError((error) => of(FinanceThresholdActions.deleteFinanceThresholdFailure({ error })))
        )
      )
    );
  });
}
